import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";

const startSchema = z.object({
  email: z.string().trim().toLowerCase().email().max(255),
  password: z.string().min(8).max(72),
});

const verifySchema = z.object({
  email: z.string().trim().toLowerCase().email().max(255),
  code: z
    .string()
    .trim()
    .regex(/^\d{6}$/, "Enter the 6-digit code"),
});

/** Creates the pending account and emails a 6-digit verification code. */
export const requestSignupCode = createServerFn({ method: "POST" })
  .inputValidator((data: unknown) => startSchema.parse(data))
  .handler(async ({ data }) => {
    const { startSignupVerification } = await import("./signup-otp.server");
    return startSignupVerification(data.email, data.password);
  });

/** Verifies the emailed code and activates the account. */
export const confirmSignupCode = createServerFn({ method: "POST" })
  .inputValidator((data: unknown) => verifySchema.parse(data))
  .handler(async ({ data }) => {
    const { verifySignupCode } = await import("./signup-otp.server");
    return verifySignupCode(data.email, data.code);
  });
